export enum BeneficiaryShareChangeTypeEnum {
  Neutral,
  Previous,
  Removed,
  New
}
